"use client";

import { Eye, FileCheck, Lock, Shield } from "lucide-react";
import { motion } from "motion/react";
import {
  FadeInUp,
  StaggerContainer,
  StaggerItem,
} from "@/components/ui/motion";

const securityItems = [
  {
    icon: Lock,
    title: "Encryption at rest & in transit",
    description:
      "All data encrypted using AES-256 at rest and TLS 1.3 in transit.",
  },
  {
    icon: Shield,
    title: "Secrets management",
    description:
      "API keys and credentials stored in isolated, encrypted vaults.",
  },
  {
    icon: Eye,
    title: "Least privilege access",
    description:
      "Role-based permissions ensure users only access what they need.",
  },
  {
    icon: FileCheck,
    title: "Audit logs",
    description: "Complete audit trail of all changes, access, and executions.",
  },
];

export function Security() {
  return (
    <section className="py-20 lg:py-28 section-elevated relative">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-success/5 to-transparent pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-4xl mx-auto">
          <FadeInUp className="text-center mb-14">
            {/* <motion.div 
              className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-success/10 border border-success/30 mb-6 shadow-lg shadow-success/10"
              whileHover={{ scale: 1.05, rotate: 5 }}
            >
              <Shield className="w-8 h-8 text-primary" />
            </motion.div> */}
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
              Security-first by <span className="gradient-text">design</span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Your workflows handle sensitive data. We treat security as a core
              feature, not an afterthought.
            </p>
          </FadeInUp>

          <StaggerContainer className="grid sm:grid-cols-2 gap-5">
            {securityItems.map((item, index) => (
              <StaggerItem key={index}>
                <motion.div
                  whileHover={{ y: -4, scale: 1.01 }}
                  className="flex gap-4 p-6 rounded-xl card-interactive hover:border-success/30"
                >
                  <div className="w-12 h-12 rounded-lg bg-success/10 border border-success/20 flex items-center justify-center flex-shrink-0">
                    <item.icon className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-foreground mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </motion.div>
              </StaggerItem>
            ))}
          </StaggerContainer>

          <FadeInUp delay={0.4} className="text-center mt-10">
            <p className="text-sm text-muted-foreground">
              Additional compliance certifications available upon request.
            </p>
          </FadeInUp>
        </div>
      </div>
    </section>
  );
}
